<template>
    <component
        :is="inDialog ? 'div' : BaseCard"
        v-bind="inDialog ? {} : { theme: 'cream', radius: 'lgr', padding: 'none' }"
        class="flex flex-col items-center"
        :class="inDialog ? 'gap-4' : 'gap-6 p-6'">
        <ReflectionIcon kind="sixty" size="hero" />
        <div class="flex flex-col gap-2.5 w-full">
            <h2 v-if="!inDialog" class="display-small-serif text-center text-ink">
                {{ hideStart ? t("reflections.sixty.howItWorksTitle") : t("reflections.sixty.start.title360") }}
            </h2>
            <p class="body text-ink-muted">
                {{ t("reflections.sixty.howItWorks.intro") }}
            </p>
        </div>

        <ol class="flex flex-col gap-5 w-full">
            <li v-for="step in steps" :key="step.n" class="flex items-start gap-4">
                <span class="flex items-center justify-center w-6.25 h-6.25 shrink-0 rounded-full bg-border scaffold-body-small text-ink">
                    {{ step.n }}
                </span>
                <p class="scaffold-body text-ink-muted">
                    <span class="font-semibold text-ink">{{ step.title }}</span>
                    {{ step.body }}
                </p>
            </li>
        </ol>

        <BaseButton v-if="!inDialog && !hideStart" type="button" theme="primary" size="sm" class="whitespace-nowrap" @click="emit('start')">{{
            t("reflections.sixty.launch")
        }}</BaseButton>
    </component>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineProps<{ inDialog?: boolean; hideStart?: boolean }>();

const emit = defineEmits<{ (event: "start"): void }>();

const { t } = useI18n();

const steps = computed(() => [
    { n: 1, title: t("reflections.sixty.howItWorks.invite.title"), body: t("reflections.sixty.howItWorks.invite.body") },
    { n: 2, title: t("reflections.sixty.howItWorks.answer.title"), body: t("reflections.sixty.howItWorks.answer.body") },
    { n: 3, title: t("reflections.sixty.howItWorks.themes.title"), body: t("reflections.sixty.howItWorks.themes.body") },
]);
</script>
